import React, {Component, Fragment} from 'react'
import './order-ticket.less'
import UserModal from './model'
import {toStrFixed, subStr} from '../../utills/subStringUtill'
import {
    reqArea, reqAddress, reqSaveTrack, reqUpdateTrack, getPackages, savePackage, updatePackage, delPackage,
    baseUrl, reqRentalBox, reqCustomsPorts, reqDeclareCities, reqBusiness, reqCabinInfoStock, reqPayInfo,
    reqCabinInfoCancelTime, reqPlanList, reqVehicleTypes, reqVehicleStock, reqTrainInfo
} from '../../api'
import {
    Form, Input, Button, DatePicker, message, Select, Table, Popconfirm, Upload, Row, Col, Spin,
    Radio, Checkbox, Icon, Tooltip, InputNumber
} from 'antd';
import CabinetTypeSelect from "../../components/cabinet-type-select";
import moment from 'moment';
import 'moment/locale/zh-cn';
import authorizePage from "../../components/authorize/authorizePage";
import authorizeBase from "../../components/authorize/authorizeBase";
import SelectAreaFormItem from '../track-edit/select-area'
import {handleChangeArea, handleChangeRentalBox, range} from '../../utills/common';
import {YgIcon, fontSize, color, color1Y, color2Y, color3Y, color4Y} from '../../components/yg-icon'
import SelectFormItem from '../../components/select-form-item'
import {
    DELIVERY_TYPE, TRAIN_PORT_DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR, SUB_TYPE,
    DEFAULT_CUSTOMS_CODE, CUSTOMS_PORT_Erlianhaote, PLAN_DELIVERY_TYPE
} from "../../utills/constants";
import {convertToRadios} from "../../components/radios";
import {convertToOptions} from "../../components/options";

const AuthFormItem = authorizeBase(Form.Item)
moment.locale('zh-cn');

const {Option} = Select;

class OrderTicket extends Component {
    state = {
        previewVisible: false,
        previewImage: '',
        visible: false,
        countryData: [],
        stateData: [],
        cityData: [],
        countryDatas: [],
        stateDatas: [],
        cityDatas: [],
        consignorData: [],// 发货方地址
        notifyPartyData: [],// 通知方地址
        deliveryPlaceData: [],// 提货地址
        packageManageVos: [],  // 表格数据
        fileList: [],
        origin: [],
        destination: [],
        originCityId: '',
        destinationCityId: '',
        consigneeData: [],
        loading: false,
        intiCityValue: '阿拉山口',
        intiCountryValue: '中国',
        rentBox: [],
        returnBox: [],
        transferType: 'w2w',
        deliveryType: 'N',
        ownBox: 'Y',
        secondPlace: false,//国内仓库
        secondNotify: false,//清关仓库(通知方)
        secondConsignee: false,//目的仓库(卸货方)
        declareModes: [],
        rowNum: 0,//下单信息添加的行数条数
        restStock: [],//剩余舱位数量
        payFlag: false,//是否需要上传凭证
        planList: [],//班次时间列表
        vehicleTypes: [],//车型：当前企业所有可选车型
        vehicleStock: [],//车型数量：每个集装箱对应所有车型的数量
        train: {},//企业订单最大天数、提前天数
        readOnly: false,
    };

    componentDidMount() {
        this.setInitAreaData('', 'F');
        this.setInitAreaData('', 'T');
        this.setInitAreaData('', 'D');
        this.setInitRentalBoxData(null, "rent_box");
        this.setInitRentalBoxData(null, "return_box");
        this.getAddress(3);
        this.getAddress(2);
        this.getAddress(1);
        this.getAddress(6);
        this.getDeclareCities();
        this.getCabinInfoCancelTime();
    }

    componentDidUpdate(preProps, preState, snapShot) {
        const {deliveryType, start, customsClearance, airStart, airEnd} = this.state;
        if (preState.deliveryType && preState.deliveryType !== deliveryType) {
            if (DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)) {
                if (deliveryType === 'D' && !(Array.isArray(start) && start.length > 0)) {
                    this.setInitAreaData('', "FS");
                }
            }
            if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && !(Array.isArray(customsClearance) && customsClearance.length > 0)) {
                this.setInitAreaData('', 'C');
            }
            if (DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType)) {
                if (!(Array.isArray(customsClearance) && customsClearance.length > 0)) {
                    this.setInitAreaData('', 'C');
                }
                if (!(Array.isArray(airStart) && airStart.length > 0)) {
                    this.setInitAreaData('', 'AF');
                }
                if (!(Array.isArray(airEnd) && airEnd.length > 0)) {
                    this.setInitAreaData('', 'AT');
                }
            }
        }
    }

    showModal = () => {
        const {orderId} = this.state;
        if (orderId) {
            this.setState({
                visible: true,
                action: 'add',
            });
        } else {
            this.setState({loading: true});
            this.handleSaveSubmit(null, 'N')
        }

    };
    setInitAreaData = async (city, type) => {
        let result = await reqArea(type);
        if (result.code === 200) {
            if (result.data.length > 0) {
                let preInit;
                if (type === 'F') {//起运地
                    preInit = city ? city : result.data[0].cityName;
                    const record = handleChangeArea(this, 'originCity', preInit, 'originCountry', 'origin', result.data, 'boxRentStation')
                    this.setDefaultValue(record.a);
                } else if (type === 'T') {//目的地
                    preInit = city ? city : result.data[0].cityName;
                    const record = handleChangeArea(this, 'destinationCity', preInit, 'destinationCountry', 'destination', result.data, 'boxReturnStation');
                    this.setDefaultValue(record.a);
                } else if (type === 'FS') {//起始站：亚欧直达
                    preInit = city ? city : result.data[0].cityName;
                    handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'start', result.data);
                } else if (type === 'D') {//转关地
                    preInit = city ? city : result.data[0].cityName;
                    handleChangeArea(this, 'internationalEndCity', preInit, 'internationalEndCountry', 'international', result.data);
                } else if (type === 'C') {//清关地
                    preInit = city ? city : result.data[0].cityName;
                    handleChangeArea(this, 'customsClearanceCity', preInit, 'customsClearanceCountry', 'customsClearance', result.data);
                } else if (type === 'AF') {//启运机场
                    preInit = city ? city : result.data[0].cityName;
                    handleChangeArea(this, 'airStartCity', preInit, 'airStartCountry', 'airStart', result.data);
                } else if (type === 'AT') {//目的机场
                    preInit = city ? city : result.data[0].cityName;
                    handleChangeArea(this, 'airEndCity', preInit, 'airEndCountry', 'airEnd', result.data);
                }
            }
        } else {
            message.error(result.message);
        }
    };
    handleChangeDestination = (e) => {
        const data = handleChangeArea(this, 'destinationCity', e, 'destinationCountry', 'destination', null, 'boxReturnStation');
        //剩余舱位
        const {deliveryType, declareMode, transferType, orderBatchPoList,} = this.props.form.getFieldsValue();
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && Array.isArray(orderBatchPoList) && orderBatchPoList.length > 0 && data.destinationCountry && transferType) {
            orderBatchPoList.forEach((o, i) => {
                if (o.estimatePortDt) {
                    this.getCabinInfoStock({
                        deliveryType,
                        declareMode,
                        estimatePortDt: o.estimatePortDt.format('YYYY-MM-DD HH:mm:ss'),
                        destinationCountry: data.destinationCountry,
                        transferType,
                    }, i)
                }
            })
        }
        //是否需上传支付凭证
        if (deliveryType && declareMode && data.destinationCountry) {
            this.getPayInfo({deliveryType, declareMode, destinationCountry: data.destinationCountry})
        }
    };
    //租箱地rent_box,还箱地return_box
    setInitRentalBoxData = async (stationValue, type) => {
        let result = await reqRentalBox(type);
        if (result.code === 200) {
            if (type === 'rent_box') {
                handleChangeRentalBox(this, 'boxRentStation', stationValue, 'rentBox', result.data)
            } else if (type === 'return_box') {
                handleChangeRentalBox(this, 'boxReturnStation', stationValue, 'returnBox', result.data);
            }
        } else {
            message.error(result.message);
        }
    };
    setDefaultValue = record => {
        if (Array.isArray(record[0].relDos) && record[0].relDos.length > 0) {
            record[0].relDos.map(o => {
                    //提货人
                    if (o.addressType == '3') {
                        this.handledeliveryPlaceChange(o.addressId);
                    }
                    //境外收货方
                    if (o.addressType == '6') {
                        this.consigneeHandleChange(o.addressId);
                    }
                    //通知方
                    if (o.addressType == '2') {
                        this.handlenotifyPartyChange(o.addressId);
                    }
                }
            );
        }
    };
// 获取地址信息
    getAddress = async (type) => {
        let result = await reqAddress(type)
        const res = result.data
        if (result.code === 200) {
            if (res.length > 0) {
                if (type === 3) {
                    this.setState({
                        deliveryPlaceData: res,
                    })
                } else if (type === 2) {
                    this.setState({
                        notifyPartyData: res,
                    })
                } else if (type === 1) {
                    this.setState({
                        consignorData: res,
                    });
                    if (result.data && result.data.length > 0) {
                        const o = result.data.filter(o => o.defalutFlag == 'Y')[0];
                        if (o) {
                            this.handleconsignorChange(o.id);
                        }
                    }
                } else if (type === 6) {
                    this.setState({
                        consigneeData: res,
                    })
                }
            }
        }
    };

    getCustomsPorts = async (deliveryType) => {
        let result = await reqCustomsPorts({deliveryType});
        if (result.code === 200) {
            if (result.data != null && Object.keys(result.data).length > 0) {
                const customsPorts = result.data.filter(o => o.customsPortCode != CUSTOMS_PORT_Erlianhaote);
                this.setState({
                    customsPorts,
                    customsPort: customsPorts[0].customsPortCode || DEFAULT_CUSTOMS_CODE.N,
                })
            }
        } else {
            message.error(result.message)
        }
    };
    getBusiness = async (customsPort, deliveryType) => {
        let result = await reqBusiness(customsPort, deliveryType);
        if (result.code === 200) {
            if (result.data != null && Object.keys(result.data).length > 0) {
                this.setState({declareModes: result.data})
            } else {
                this.setState({declareModes: []})
            }
        } else {
            message.error(result.message)
        }
    };
    getCabinInfoCancelTime = async () => {
        let result = await reqCabinInfoCancelTime();
        if (result.code === 200) {
            this.setState({cancelTime: result.data,})
        } else {
            message.error(result.message)
        }
    }
    //剩余舱位查询
    getCabinInfoStock = async (po, i) => {
        let result = await reqCabinInfoStock(po);
        if (result.code === 200) {
            const oldRestStock = this.state.restStock;
            oldRestStock[i] = result.data;
            this.setState({restStock: oldRestStock})
        } else {
            message.error(result.message)
        }
    }
    //是否需要支付凭证
    getPayInfo = async (po) => {
        let result = await reqPayInfo(po);
        if (result.code === 200) {
            this.setState({payFlag: result.data})
        } else {
            message.error(result.message)
        }
    };
    getDeclareCities = async () => {
        let result = await reqDeclareCities();
        if (result.code === 200) {
            this.setState({
                declareCities: [...result.data],
            })
        } else {
            message.error(result.message)
        }
    }
    //班次时间查询
    getPlanList = async (deliveryType) => {
        let result = await reqPlanList(deliveryType);
        if (result.code === 200) {
            const planList = {};
            result.data.forEach((o, i) => {
                const planDt = subStr(o.planDt)
                planList[planDt] = planDt + '(余' + o.otherCount + ')';
            })
            this.setState({planList})
        } else {
            message.error(result.message)
        }
    }
    //车型
    getVehicleTypes = async (po) => {
        let result = await reqVehicleTypes(po);
        if (result.code === 200) {
            this.setState({vehicleTypes: result.data})
        } else {
            message.error(result.message)
        }
    }
    //剩余车型数量
    getVehicleStock = async (data, i) => {
        //i：集装箱下标
        const oldVehicleStock = this.state.vehicleStock;
        let result = await reqVehicleStock(data);
        if (result.code === 200) {
            if (result.data) {
                oldVehicleStock[i] = result.data;
                this.setState({vehicleStock: oldVehicleStock})
            }
        } else {
            message.error(result.message)
        }
    }
    //企业订舱天数
    getTrainInfo = async (deliveryType) => {
        let result = await reqTrainInfo({deliveryType});
        if (result.code === 200) {
            this.setState({train: result.data})
        } else {
            message.error(result.message)
        }
    };
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        } else {
            message.error(result.message)
            return false;
        }
    };
    handleChange = info => {
        let fileList = [...info.fileList];
        fileList = fileList.map(file => {
            if (file.response) {
                if (file.response.code === 200) {
                    file.url = baseUrl + '/' + file.response.data.filePath;
                    file.id = file.response.data.id;
                } else {
                    file.status = 'error';
                    file.response = file.response.message;
                }
            }
            return file;
        });

        this.setState({fileList});
    };

    handleSaveSubmit = (e, isCommit) => {
        if (e) {
            e.preventDefault();
        }
        this.props.form.validateFieldsAndScroll((err, values) => {
            const {packageManageVos, fileList,} = this.state;

            if (err) {
                this.setState({loading: false});
                return;
            } else {
                values.packageManagePos = packageManageVos;
                values.trainDt = values.trainDt ? values.trainDt.format('YYYY-MM-DD') : '';
                values.isCommit = isCommit;
                /*二连浩特修改 */
                values.originCountry = this.state.originCountry;
                values.originEndCountry = this.state.intiCountryValue;
                values.originEndCity = this.state.customsPorts.filter(c => c.customsPortCode === values.customsPort)[0].customsPortName;
                if (values.internationalEndCity) {
                    values.internationalEndCountry = this.state.internationalEndCountry;
                }
                if (values.customsClearanceCity) {
                    values.customsClearanceCountry = this.state.customsClearanceCountry;
                }
                if (values.airStartCity) {//启运机场
                    values.airStartCountry = this.state.airStartCountry;
                }
                if (values.airEndCity) {//目的机场
                    values.internationalEndCity = this.state.airEndCity;
                    values.internationalEndCountry = this.state.airEndCountry;
                }
                values.destinationCountry = this.state.destinationCountry;
                /*二连浩特修改 */
                if (fileList && fileList.length > 0) {
                    let fileids = [];
                    fileList.forEach((item) => {
                        if (item.id) {
                            fileids.push(item.id);
                        }
                    });
                    values.fileIds = fileids;
                }
                if (values.boxRentStation === undefined) {
                    values.boxRentStation = ''
                }
                if (values.boxReturnStation === undefined) {
                    values.boxReturnStation = ''
                }
                //下单信息
                values.orderBatchPoList.forEach((o => {
                    const vehicleTypes = [];
                    o.deliveryEstimateDt = o.deliveryEstimateDt ? o.deliveryEstimateDt.format('YYYY-MM-DD HH') : '';
                    o.estimatePortDt = o.estimatePortDt ? o.estimatePortDt.format('YYYY-MM-DD HH') : '';
                    for (let key in o.vehicleTypes) {
                        vehicleTypes.push({vehicleType: key, num: o.vehicleTypes[key]})
                    }
                    o.vehicleTypes = vehicleTypes;
                }));
                this.saveTrackData(values, e, isCommit)
            }
        });
    }

    saveTrackData = async (data, e, isCommit) => {
        const {orderId, payFlag} = this.state;
        if (orderId) {
            data.id = orderId;
            let result = await reqUpdateTrack(data)
            if (result.code === 200) {
                this.props.history.replace('/trackList')
            } else {
                message.error(result.message)
            }
        } else {

            let result = await reqSaveTrack(data)
            if (result.code === 201) {
                //  if (isCommit == 'Y') {
                if (payFlag) {
                    message.warning('保存成功，请尽快上传支付凭证');
                }
                this.props.history.replace('/trackList')
                /*} else {
                 if (!e) {
                 this.showModal();
                 }
                 this.setState({orderId: result.data.id, orderNo: result.data.orderNo, loading: false})
                 }*/
            } else {
                message.error(result.message)
            }
        }

    }
    getInformation = (o) => {
        const address = (o.country ? o.country : '') + (o.state ? o.state : '') + (o.city ? o.city : '') + o.address;
        const tel = [];
        if (o.phone) {
            tel.push(o.phone)
        }
        if (o.email) {
            tel.push(o.email)
        }
        return {address, tel}
    };

// 发货企业变化时
    handleconsignorChange = (key) => {
        const {consignorData} = this.state;
        consignorData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    shipper: o.company,
                    shipperAddr: address,
                    shipperContact: o.contact,
                    shipperTel: tel.toString()
                })
            }
        })
    };
    consigneeHandleChange = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee: o.company,
                    consigneeAddr: address,
                    consigneeContact: o.contact,
                    consigneeTel: tel.toString(),
                    consigneeCustomsCode: o.customsCode
                });
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
    consigneeHandleChange2 = (addrId) => {
        const {consigneeData} = this.state;
        consigneeData.map(o => {
            if (o.id == addrId) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    consignee2: o.company,
                    consigneeAddr2: address,
                    consigneeContact2: o.contact,
                    consigneeTel2: tel.toString(),
                    consigneeCustomsCode2: o.customsCode
                });
                this.handleChangeSame(this.state.sameConsignee);
            }
        })
    };
    // 通知方变化时
    handlenotifyPartyChange = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty: o.company,
                    notifyPartyAddr: address,
                    notifyPartyContact: o.contact,
                    notifyPartyTel: tel.toString(),
                    notifyPartyCustomsCode: o.customsCode
                })
            }
        })
    };
    // 通知方变化时2
    handlenotifyPartyChange2 = (key) => {
        const {notifyPartyData} = this.state;
        notifyPartyData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    notifyParty2: o.company,
                    notifyPartyAddr2: address,
                    notifyPartyContact2: o.contact,
                    notifyPartyTel2: tel.toString(),
                    notifyPartyCustomsCode2: o.customsCode
                })
            }
        })
    };
    // 提货方变化时
    handledeliveryPlaceChange = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace: address,
                    contact: o.contact,
                    contactTel: tel.toString()
                })
            }
        })
    };
    // 提货方变化时2
    handledeliveryPlaceChange2 = (key) => {
        const {deliveryPlaceData} = this.state;
        deliveryPlaceData.forEach((o, i) => {
            if (key === o.id) {
                const {address, tel} = this.getInformation(o);
                this.props.form.setFieldsValue({
                    deliveryPlace2: address,
                    contact2: o.contact,
                    contactTel2: tel.toString()
                })
            }
        })
    };
//添加表格
    onOk = async (updateData) => {
        const {action, page, pageSize, orderId} = this.state;
        updateData.orderId = orderId;
        if (updateData.value !== undefined && updateData.pcsNumber !== undefined) {
            updateData.totalValue = toStrFixed(updateData.value * updateData.pcsNumber);
        }
        if (action === 'add') {
            let result = await savePackage(updateData);
            if (result.code == 201) {
                this.onCancel();
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        } else {
            let result = await updatePackage(updateData);
            if (result.code == 200) {
                this.onCancel();
                this.goods(orderId, page, pageSize);
            } else {
                message.error(result.message);
            }
        }
    }

    onCancel = () => {
        this.setState({
            visible: false
        })
    }

//显示弹窗
    editDataSource = (data) => {
        this.setState({
            visible: true,
            action: 'edit'
        })
        this.child.props.form.setFieldsValue(data);

    }

    handleDelete = async (id) => {
        let result = await delPackage(id, this.state.orderId);
        if (result.code == 200) {
            this.goods(this.state.orderId);
        } else {
            message.error(result.message);
        }
    };

    onRef = (ref) => {
        this.child = ref
    };
    // 日期选择
    onDateChange = (current, dateString, i) => {
        const {deliveryType, transferType, declareMode} = this.props.form.getFieldsValue();
        if (!DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && current) {
            //年月日
            const dateStart = moment().add('days', 6).startOf('day');
            if (current < dateStart) {
                current.add('days', 6);
                dateString = current.format('YYYY-MM-DD HH');
            }
            //小时
            const dateEnd = moment().add('days', 6).endOf('day');
            if (current < dateEnd) {
                const hour = new Date().getHours();
                if (current.hour() <= hour) {
                    current.hour(hour + 1);
                    dateString = current.format('YYYY-MM-DD HH');
                }
            }
        }
        //剩余车型数量
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' && (transferType === 'w2w' || transferType === 's2w') && current) {
            this.getVehicleStock({deliveryType, deliveryEstimateDt: dateString}, i)
        }
    };
    disabledStartDate = (current) => {
        const {deliveryType} = this.props.form.getFieldsValue();
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType)) {
            return current && current < moment().endOf('day');
        } else {
            return current && current < moment().add('days', 5).endOf('day');
        }
    };
    disabledDateTime = (current) => {
        const {deliveryType} = this.props.form.getFieldsValue();
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType)) {
            return false
        } else {
            if (current && current < moment().add('days', 6).endOf('day')) {
                const hour = new Date().getHours();
                return {
                    disabledHours: () => range(0, hour + 1),
                };
            }
        }
    };
    //预计到达口岸日期选择:只有公路有预计到达口岸
    handleChangeEstimatePortDt = (current, dateString, i) => {
        //剩余舱位
        const {deliveryType, transferType, declareMode} = this.props.form.getFieldsValue();
        const {destinationCountry,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && current && destinationCountry && transferType) {
            this.getCabinInfoStock({
                deliveryType,
                declareMode,
                estimatePortDt: dateString,
                destinationCountry,
                transferType,
            }, i)
        }
    };
    //预计出境日期选择
    disabledLeaveCountryDt = (current) => {
        const {train} = this.state;
        //提前天数
        const preDay = moment().add('days', train.monthDay - 1).endOf('day');
        //当月最后一天
        const lastDay = moment().endOf('month');
        // a.预计出境日期 - 当前日期 ≥ 10。
        const a = current < moment().add('days', 9).endOf('day');
        // b.当前日期 + 提前天数如果日期仍为当月，则预计出境日期只能选本月。
        const b = current > lastDay;
        // c.下月最后一天
        const c = current > moment().add('month', 1).endOf('month');
        if (preDay < lastDay) {
            return a || b
        } else {
            return a || c
        }
    };
    importChange = info => {
        let fileList = [...info.fileList];
        let complete = 0;
        fileList = fileList.map(file => {
            if (file.response) {
                // Component will show file.url as link
                if (file.response.code === 200) {
                    message.info(file.response.message);
                    this.goods(this.state.orderId);
                } else if (file.response.code === 205) {
                    message.error(file.response.message)
                    window.location.href = baseUrl + '/' + file.response.data;
                } else {
                    message.error(file.response.message)
                }
                file.status = 'done';
                complete = 1;
            }
            return file;
        });
        if (complete === 1) {
            this.setState({
                importList: []
            })
        } else {
            this.setState({importList: fileList});
        }
    };

    downloadModel = () => {
        window.location.href = baseUrl.replace('/oms', '/upload') + '/template/货物管理导入模板.xlsx';
    }
    search = e => {
        e.preventDefault();
        const {orderId, page, pageSize} = this.state;
        this.goods(orderId, page, pageSize);
    };
    handleChangeSame = (checked) => {
        if (checked) {
            const {
                notifyParty, notifyPartyAddr, notifyPartyContact, notifyPartyTel, notifyPartyCustomsCode,
                notifyParty2, notifyPartyAddr2, notifyPartyContact2, notifyPartyTel2, notifyPartyCustomsCode2,
            } = this.props.form.getFieldsValue();
            this.setState({secondConsignee: this.state.secondNotify}, function () {
                this.props.form.setFieldsValue({
                    consignee: notifyParty,
                    consigneeAddr: notifyPartyAddr,
                    consigneeContact: notifyPartyContact,
                    consigneeTel: notifyPartyTel,
                    consigneeCustomsCode: notifyPartyCustomsCode,
                    consignee2: notifyParty2,
                    consigneeAddr2: notifyPartyAddr2,
                    consigneeContact2: notifyPartyContact2,
                    consigneeTel2: notifyPartyTel2,
                    consigneeCustomsCode2: notifyPartyCustomsCode2,
                });
            })
        }
        this.setState({sameConsignee: checked})
    };
    handleCustomsPort = (e, deliveryType) => {
        this.setState({customsPort: e,});
        this.getBusiness(e, deliveryType ? deliveryType : this.state.deliveryType);
        this.props.form.setFieldsValue({declareMode: '', customsPort: e});
    };
    handleDeclareMode = (value) => {
        let declareCityRequired = false;
        if (value === '转关运输') {
            declareCityRequired = true;
        }
        this.setState({declareCityRequired});
        //剩余舱位
        const {deliveryType, transferType, orderBatchPoList} = this.props.form.getFieldsValue();
        const {destinationCountry,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && value && Array.isArray(orderBatchPoList) && orderBatchPoList.length > 0 && destinationCountry && transferType) {
            orderBatchPoList.forEach((o, i) => {
                if (o.estimatePortDt) {
                    this.getCabinInfoStock({
                        deliveryType,
                        declareMode: value,
                        estimatePortDt: o.estimatePortDt.format('YYYY-MM-DD HH:mm:ss'),
                        destinationCountry,
                        transferType,
                    }, i)
                }
            })
        }
        //是否需上传支付凭证
        if (deliveryType && value && destinationCountry) {
            this.getPayInfo({deliveryType, declareMode: value, destinationCountry})
        }
    }
    handleDeliveryType = (value) => {
        message.info('您已选择' + DELIVERY_TYPE[value]);
        this.setState({deliveryType: value,});
        const {subType, transferType, start, airStart} = this.state;
        //服务模式
        if (DELIVERY_TYPE_MIX.hasOwnProperty(value) || value === 'M') {
            this.props.form.setFieldsValue({subType: null,});
            this.setState({subType: null,});
        } else {
            if (!subType) {
                this.props.form.setFieldsValue({subType: 'A',});
                this.setState({subType: 'A',});
            }
        }
        if (DELIVERY_TYPE_MIX.hasOwnProperty(value) || DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value)) {
            this.props.form.setFieldsValue({transferType: 'w2w',});
            this.handleTransferType('w2w');
        }
        if (DELIVERY_TYPE_AIR.hasOwnProperty(value)) {//默认口岸到启运机场
            this.props.form.setFieldsValue({transferType: 'p2as',});
            this.handleTransferType('p2as');
        }
        //出境口岸
        this.getCustomsPorts(value);
        this.handleCustomsPort(DEFAULT_CUSTOMS_CODE[value], value);//默认口岸
        //起始站、启运机场默认值
        if (DELIVERY_TYPE_AIR.hasOwnProperty(value)) {
            this.props.form.setFieldsValue({airStartCity: Array.isArray(airStart) && airStart.length > 0 ? airStart[0].cityName : ''});
        } else {
            this.props.form.setFieldsValue({airStartCity: Array.isArray(start) && start.length > 0 ? start[0].cityName : ''});
        }
        const {declareMode, orderBatchPoList} = this.props.form.getFieldsValue();
        const {destinationCountry,} = this.state;
        //预计提货时间
        orderBatchPoList.forEach((o, i) => {
            if (o.deliveryEstimateDt) {
                const name = `orderBatchPoList[${i}].deliveryEstimateDt`;
                this.props.form.setFieldsValue({[name]: null});
            }
        })
        //剩余舱位
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value) && declareMode && Array.isArray(orderBatchPoList) && orderBatchPoList.length > 0 && destinationCountry && transferType) {
            orderBatchPoList.forEach((o, i) => {
                if (o.estimatePortDt) {
                    this.getCabinInfoStock({
                        deliveryType: value,
                        declareMode,
                        estimatePortDt: o.estimatePortDt.format('YYYY-MM-DD HH:mm:ss'),
                        destinationCountry,
                        transferType,
                    }, i)
                }
            })
        }
        //是否需上传支付凭证
        if (value && declareMode && destinationCountry && destinationCountry) {
            this.getPayInfo({deliveryType: value, declareMode, destinationCountry})
        }
        //班次时间
        if (PLAN_DELIVERY_TYPE.hasOwnProperty(value)) {
            this.getPlanList(value)
        }
        //车型
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(value) && value !== 'M' && (transferType === 'w2w' || transferType === 's2w')) {
            this.getVehicleTypes({deliveryType: value})
        }
        //企业订舱天数：霍欧中铁班车
        if (TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(value)) {
            this.getTrainInfo(value)
        }
    }
    handleTransferType = (value) => {
        //剩余舱位
        const {deliveryType, declareMode, orderBatchPoList,} = this.props.form.getFieldsValue();
        const {destinationCountry, vehicleTypes,} = this.state;
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && declareMode && Array.isArray(orderBatchPoList) && orderBatchPoList.length > 0 && destinationCountry && value) {
            orderBatchPoList.forEach((o, i) => {
                if (o.estimatePortDt) {
                    this.getCabinInfoStock({
                        deliveryType,
                        declareMode,
                        estimatePortDt: o.estimatePortDt.format('YYYY-MM-DD HH:mm:ss'),
                        destinationCountry,
                        transferType: value,
                    }, i)
                }
            })
        }
        //车型
        if (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' && (value === 'w2w' || value === 's2w')
            && Array.isArray(vehicleTypes) && vehicleTypes.length === 0) {
            this.getVehicleTypes({deliveryType})
        }
        this.setState({transferType: value})
    }
    handOwnBox = (e) => {
        this.setState({ownBox: e.target.value})
    }
    addBox = (e) => {
        const {rowNum} = this.state;
        if (rowNum >= 0) {
            this.setState({rowNum: rowNum + 1})
        } else {
            this.setState({rowNum: 0})
        }
    }
    removeBox = () => {
        const {rowNum} = this.state;
        this.setState({rowNum: rowNum - 1})
    }

    render() {
        const {getFieldDecorator, setFieldsValue} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                md: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                md: {span: 14},
            },
        }
        const formItemLayout2 = {labelCol: {md: {span: 16},}, wrapperCol: {md: {span: 8},},}
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                md: {
                    span: 24,
                    offset: 0,
                },
            },
        }
        const {
            visible, notifyPartyData, deliveryPlaceData, consigneeData, updateKey,
            transferType, deliveryType, subType,
            insureFeeType, transitFeeType, ownBox, secondPlace, secondNotify, secondConsignee,
            rowNum, restStock, payFlag, cancelTime,
            vehicleTypes, vehicleStock,
        } = this.state;
        //车型是否展示
        const vehicleFlag = DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' && (transferType === 'w2w' || transferType === 's2w');
        const rows = [];
        for (let i = 0; i < rowNum; i++) {
            rows.push(<Fragment>
                <Row>
                    <Col span={8}>
                        <Form.Item label="集装箱数">
                            {getFieldDecorator(`orderBatchPoList[${i + 1}].quantity`, {
                                initialValue: '1',
                                rules: [{required: true, message: '该项必填'}, {
                                    pattern: /^[1-9]\d*$/, message: '必须为大于0的整数'
                                }]
                            })(<Input placeholder='集装箱数' readOnly={this.state.readOnly}/>)}
                        </Form.Item>
                    </Col>
                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                        <Fragment>
                            <Col span={8}>
                                <Form.Item label="预计到达口岸" {...formItemLayout}>
                                    {getFieldDecorator(`orderBatchPoList[${i + 1}].estimatePortDt`, {
                                        rules: [{required: true, message: '该项必填'}],
                                    })(<DatePicker format="YYYY-MM-DD HH" style={{width: '100%'}}
                                                   disabledDate={this.disabledStartDate}
                                                   disabledTime={this.disabledDateTime}
                                                   showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                                   onChange={(current, dateString) => this.handleChangeEstimatePortDt(current, dateString, i + 1)}
                                    />)}
                                </Form.Item>
                            </Col>
                            {restStock[i + 1] != null ?
                                <Col span={8}>
                                    <Form.Item label="剩余舱位">
                                        {getFieldDecorator('stock', {})(
                                            <span>{restStock[i + 1]}</span>)}
                                    </Form.Item>
                                </Col> : null}
                        </Fragment> : null}
                    <Col span={8}>
                        <Form.Item label="预计提货时间" {...formItemLayout}>
                            {getFieldDecorator(`orderBatchPoList[${i + 1}].deliveryEstimateDt`, {
                                rules: [{required: true, message: '该项必填'}],
                            })(<DatePicker
                                format="YYYY-MM-DD HH" style={{width: '100%'}}
                                onChange={(current, dateString) => this.onDateChange(current, dateString, i + 1)}
                                disabledDate={this.disabledStartDate}
                                disabledTime={this.disabledDateTime}
                                showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                            />)}
                        </Form.Item>
                    </Col>
                    {TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                        <Col span={8}>
                            <Form.Item label="预计出境时间" {...formItemLayout}>
                                {getFieldDecorator(`orderBatchPoList[${i + 1}].leaveCountryDt`, {
                                    rules: [{required: true, message: '该项必填'}],
                                })(<DatePicker format="YYYY-MM-DD" style={{width: '100%'}}
                                               disabledDate={this.disabledLeaveCountryDt}
                                />)}
                            </Form.Item>
                        </Col> : null}
                    {i === rowNum - 1 && !vehicleFlag ?
                        <Col span={4}>
                            <Button type='link' onClick={this.removeBox}><Icon
                                type="delete"/></Button></Col> : null}
                    {vehicleFlag ? <Fragment>
                        {vehicleTypes.map((o, j) => {
                            return <Col span={4}>
                                <Form.Item {...formItemLayout2}
                                           label={vehicleStock.length > 0 && vehicleStock[i + 1] && vehicleStock[i + 1][o] ?
                                               '车型' + o + '(余' + vehicleStock[i + 1][o] + ')' : '车型' + o}>
                                    {getFieldDecorator(`orderBatchPoList[${i + 1}].vehicleTypes[` + o + `]`, {
                                        initialValue: j === 0 ? 1 : null,
                                    })(<InputNumber min={0} step={1} style={{width: '90%'}}/>)}
                                </Form.Item>
                            </Col>
                        })}
                        {i === rowNum - 1 ?
                            <Col span={3} push={1}>
                                <Button type='link' onClick={this.removeBox}><Icon type="delete"/></Button>
                            </Col> : null}
                    </Fragment> : null}
                </Row>
            </Fragment>)
        }
        //取消时间提示
        const restCancelTime = restStock.filter(o => {
            return o != null
        });
        const radios = [];
        for (let key in SUB_TYPE) {
            if (key === 'A') {
                radios.push(<Radio key={key} value={key}>{SUB_TYPE[key]}&nbsp;
                    <Tooltip title="以国际标准集装箱为载货容器，为委托方提供自中国境内仓库装箱后运输至中亚及欧洲一站式运输服务，途中不更换载货容器。">
                        <YgIcon type="icon-wenhaow"/>
                    </Tooltip>
                </Radio>)
            } else {
                radios.push(<Radio key={key} value={key}>{SUB_TYPE[key]}&nbsp;
                    <Tooltip
                        title="使用厢式货车载运国内货物至边境口岸后，将出口货物倒装至“跨境集装器”后摆渡过境，在境外将“跨境集装器”中货物倒装至二次倒装至厢式货车，并完成境外全程运输任务。">
                        <YgIcon type="icon-wenhaow"/>
                    </Tooltip>
                </Radio>)
            }
        }
        //国内仓库、目的仓库非必填：公路和空运的口岸服务
        const whRequired = DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || transferType !== 'p2p';
        //清关仓库非必填：公路的口岸服务、空运
        const declareWhRequired = !(DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && transferType === 'p2p')
            && !DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType);
        return (
            <div className='order-ticket box-shadow'>
                <div className="head-title">
                    新建委托单
                </div>
                <div className="order-ticket-content">
                    <Spin spinning={this.state.loading}>
                        <Form {...formItemLayout} onSubmit={e => this.handleSaveSubmit(e, 'N')}>
                            <div className="order-spaceInfo-content">
                                <div className='content-head-title'>委托类型</div>
                                <div className='spaceInfo-content-info'>
                                    <Row className='Row route-planning-before'>
                                        <Col span={24}>
                                            <Form.Item label="运输类型" {...{
                                                labelCol: {span: 6,},
                                                wrapperCol: {span: 18}
                                            }}>{getFieldDecorator('deliveryType', {
                                                rules: [{required: true, message: '该项必填'}]
                                            })(<Radio.Group disabled={this.state.readOnly}
                                                            onChange={e => this.handleDeliveryType(e.target.value)}>
                                                {convertToRadios(DELIVERY_TYPE)}
                                            </Radio.Group>)}
                                            </Form.Item>
                                        </Col>
                                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M' ?
                                            <Col span={24}>
                                                <Form.Item label="服务类型" {...{
                                                    labelCol: {span: 6,},
                                                    wrapperCol: {span: 18}
                                                }}>
                                                    {getFieldDecorator('subType', {
                                                        initialValue: 'A',
                                                        rules: [{required: true, message: '该项必填'}]
                                                    })(<Radio.Group disabled={this.state.readOnly}
                                                                    onChange={e => this.setState({subType: e.target.value})}>
                                                        {radios}
                                                    </Radio.Group>)}
                                                </Form.Item> </Col> : null}
                                        <Col span={24}>
                                            <Form.Item label="委托方式" {...{
                                                labelCol: {span: 6,},
                                                wrapperCol: {span: 18}
                                            }}>
                                                {getFieldDecorator('transferType', {
                                                    initialValue: transferType,
                                                    rules: [{required: true, message: '该项必填'}]
                                                })(<Radio.Group disabled={this.state.readOnly}
                                                                onChange={e => this.handleTransferType(e.target.value)}>
                                                    <Radio value='w2w'>仓到仓 <Tooltip title="全程都由我司承运。">
                                                        <YgIcon type="icon-wenhaow"/>
                                                    </Tooltip>{/*<br/><span className="tips-label">最省心</span>*/}</Radio>
                                                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                                        (deliveryType === 'D' ?
                                                            <Fragment>
                                                                <Radio value='w2s'>仓到站 <Tooltip
                                                                    title="从起运地到目的站由我司承运，从目的站到目的仓为贵司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip></Radio>
                                                                <Radio value='p2s'>口岸到站 <Tooltip
                                                                    title="从起运地到口岸为贵司承运，从口岸到目的站由我司承运，从目的站到目的仓由贵司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip></Radio>
                                                                <Radio value='p2w'>口岸到仓 <Tooltip
                                                                    title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip>
                                                                </Radio>
                                                            </Fragment> :
                                                            <Fragment>
                                                                <Radio value='w2s'>仓到站 <Tooltip
                                                                    title="从起运地到转关地由我司承运，从转关地到目的仓为贵司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip></Radio>
                                                                <Radio value='s2s'>站到站 <Tooltip
                                                                    title="从起运地到口岸为贵司承运，从口岸到转关地由我司承运，从转关地到目的仓由贵司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip></Radio>
                                                                <Radio value='s2w'>站到仓 <Tooltip
                                                                    title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                                    <YgIcon type="icon-wenhaow"/>
                                                                </Tooltip></Radio>
                                                            </Fragment>)
                                                        : null}
                                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                                        <Fragment>
                                                            <Radio value='w2p'>仓到口岸 <Tooltip
                                                                title="从起运地到口岸为我司承运，从口岸到目的仓由贵司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='p2p'>口岸服务 <Tooltip
                                                                title="在口岸接收委托方货物，并根据客户要求完成出口报关、集装箱过境/倒装过境/境外倒装任务，由委托方自行完成境内外车辆调度及运输。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='s2w'>口岸到仓 <Tooltip
                                                                title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                        </Fragment> : null}
                                                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                        <Fragment>
                                                            <Radio value='w2as'>仓到启运机场 <Tooltip
                                                                title="从起运地到启运机场为我司承运，从启运机场到目的仓为贵司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='w2a'>仓到目的机场 <Tooltip
                                                                title="从起运地到目的机场为我司承运，从目的机场到目的仓为贵司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='p2p'>口岸服务 <Tooltip
                                                                title="在口岸接收委托方货物，并根据客户要求完成出口报关、集装箱过境/倒装过境/境外倒装任务，由委托方自行完成境内外车辆调度及运输。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='p2as'>口岸到启运机场 <Tooltip
                                                                title="从起运地到口岸为贵司承运，从口岸到启运机场为我司承运，从启运机场到目的仓为贵司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='p2a'>口岸到目的机场 <Tooltip
                                                                title="从起运地到口岸为贵司承运，从口岸到目的机场为我司承运，从目的机场到目的仓为贵司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                            <Radio value='p2w'>口岸到仓 <Tooltip
                                                                title="从起运地到口岸为贵司承运，从口岸到目的仓为我司承运。">
                                                                <YgIcon type="icon-wenhaow"/>
                                                            </Tooltip>
                                                            </Radio>
                                                        </Fragment> : null}
                                                </Radio.Group>)}
                                            </Form.Item>
                                        </Col>
                                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A') ?
                                            <Col span={24}>
                                                <Form.Item label="是否自备箱" {...{
                                                    labelCol: {span: 6,},
                                                    wrapperCol: {span: 18}
                                                }}>
                                                    {getFieldDecorator('ownBox', {
                                                        initialValue: ownBox,
                                                        rules: [{required: true, message: '该项必填'}]
                                                    })(<Radio.Group disabled={this.state.readOnly}
                                                                    onChange={this.handOwnBox}
                                                    >
                                                        <Radio value='Y'>是</Radio>
                                                        <Radio value='N'>否</Radio>
                                                    </Radio.Group>)}
                                                </Form.Item>
                                            </Col> : null}
                                    </Row>
                                    <Row>
                                        <Col span={6}><span className="form-label">线路规划:</span></Col>
                                        <Col span={18}>
                                            <div className='route-planning'>
                                                <div className="column2">
                                                    <div className="circle-line">
                                                        <div
                                                            className={transferType == 'w2w' || transferType == 'w2s' || transferType == 'w2p' || transferType == 'w2a' || transferType == 'w2as' ? 'circle-on' : 'circle'}>
                                                            <span>仓</span>
                                                        </div>
                                                        <div
                                                            className={transferType == 'w2w' || transferType == 'w2s' || transferType == 'w2p' || transferType == 'w2a' ? 'line-on' : 'line'}></div>
                                                        <div>
                                                            <div
                                                                className={transferType ? 'circle-on' : 'circle'}></div>
                                                            <div
                                                                className="circle-text">{DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) && deliveryType !== 'D' ? '站' : '口岸'}</div>
                                                        </div>
                                                        {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                                            <Fragment>
                                                                {deliveryType === 'D' ?
                                                                    <Fragment>
                                                                        <div className='line-on'></div>
                                                                        <div className='circle-on'></div>
                                                                    </Fragment> : null}
                                                                <div className='line-on'></div>
                                                                <div className='circle-on'><span>站</span></div>
                                                                <div
                                                                    className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                            </Fragment> : null}
                                                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                                            <Fragment>
                                                                <div
                                                                    className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                                <div
                                                                    className={transferType == 'w2w' || transferType == 's2w' ? 'circle-on' : 'circle'}></div>
                                                                <div
                                                                    className={transferType == 'w2w' || transferType == 's2w' ? 'line-on' : 'line'}></div>
                                                            </Fragment> : null}
                                                        {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                            <Fragment>
                                                                <div className='line-on'></div>
                                                                <div className='circle-on'></div>
                                                                <div
                                                                    className={!(transferType == 'w2as' || transferType == 'p2as') ? 'line-on' : 'line'}></div>
                                                                <div
                                                                    className={!(transferType == 'w2as' || transferType == 'p2as') ? 'circle-on' : 'circle'}></div>
                                                                <div
                                                                    className={transferType == 'w2w' || transferType == 'p2w' ? 'line-on' : 'line'}></div>
                                                                <div
                                                                    className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'circle-on' : 'circle'}></div>
                                                                <div
                                                                    className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'line-on' : 'line'}></div>
                                                            </Fragment> : null}
                                                        <div
                                                            className={(transferType == 'w2w' || transferType == 's2w' || transferType == 'p2w') ? 'circle-on' : 'circle'}>
                                                            <span>仓</span></div>
                                                    </div>
                                                </div>
                                                <div className="column3">
                                                    <SelectAreaFormItem
                                                        label='起运地'
                                                        name="originCity"
                                                        getFieldDecorator={getFieldDecorator}
                                                        initialValue={this.state.originCity}
                                                        handleChange={e => {
                                                            handleChangeArea(this, 'originCity', e, 'originCountry', 'origin', null, 'boxRentStation')
                                                        }}
                                                        disabledOpt={this.state.readOnly}
                                                        data={[...this.state['origin']]}
                                                    />
                                                    <SelectFormItem
                                                        label={PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ? '起始站' : '出境口岸'}
                                                        name="customsPort"
                                                        getFieldDecorator={getFieldDecorator}
                                                        initialValue={this.state.customsPort}
                                                        required={true}
                                                        data={this.state.customsPorts}
                                                        dataValue='customsPortCode'
                                                        dataContent='customsPortName'
                                                        handleChange={value => this.handleCustomsPort(value)}
                                                    />
                                                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                        <SelectAreaFormItem
                                                            label='启运机场'
                                                            name="airStartCity"
                                                            getFieldDecorator={getFieldDecorator}
                                                            initialValue={this.state.airStartCity}
                                                            disabledOpt={this.state.readOnly}
                                                            data={this.state.airStart}
                                                            handleChange={e => {
                                                                handleChangeArea(this, 'airStartCity', e, 'airStartCountry', 'airStart');
                                                            }}
                                                        /> : null}
                                                    {deliveryType === 'D' ?
                                                        <SelectAreaFormItem
                                                            label='起始站'
                                                            name="airStartCity"
                                                            getFieldDecorator={getFieldDecorator}
                                                            initialValue={this.state.airStartCity}
                                                            disabledOpt={this.state.readOnly}
                                                            data={this.state.start}
                                                            handleChange={e => {
                                                                handleChangeArea(this, 'airStartCity', e, 'airStartCountry', 'start');
                                                            }}
                                                        /> : null}
                                                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                                                        <SelectAreaFormItem
                                                            label={PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) || deliveryType === 'D' ? '目的站' : '转关地'}
                                                            name="internationalEndCity"
                                                            getFieldDecorator={getFieldDecorator}
                                                            initialValue={this.state.internationalEndCity}
                                                            disabledOpt={this.state.readOnly}
                                                            data={this.state.international}
                                                            handleChange={e => {
                                                                handleChangeArea(this, 'internationalEndCity', e, 'internationalEndCountry', 'international');
                                                            }}
                                                        /> : null}
                                                    {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                        <SelectAreaFormItem
                                                            label='目的机场'
                                                            name="airEndCity"
                                                            getFieldDecorator={getFieldDecorator}
                                                            initialValue={this.state.airEndCity}
                                                            disabledOpt={this.state.readOnly}
                                                            data={this.state.airEnd}
                                                            handleChange={e => {
                                                                handleChangeArea(this, 'airEndCity', e, 'airEndCountry', 'airEnd');
                                                            }}
                                                        /> : null}
                                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                                                        <SelectAreaFormItem
                                                            label='清关地'
                                                            name="customsClearanceCity"
                                                            getFieldDecorator={getFieldDecorator}
                                                            initialValue={this.state.customsClearanceCity}
                                                            disabledOpt={this.state.readOnly}
                                                            data={this.state.customsClearance}
                                                            handleChange={e => {
                                                                handleChangeArea(this, 'customsClearanceCity', e, 'customsClearanceCountry', 'customsClearance');
                                                            }}
                                                        /> : null}
                                                    <SelectAreaFormItem
                                                        label='目的地'
                                                        name="destinationCity"
                                                        getFieldDecorator={getFieldDecorator}
                                                        initialValue={this.state.destinationCity}
                                                        disabledOpt={this.state.readOnly}
                                                        data={this.state.destination}
                                                        handleChange={this.handleChangeDestination}
                                                    />{/*<span>请选择目的地客服为您推荐最低价的还箱地</span>*/}
                                                    {/*<div><span><p className="circle">0</p>呜呜网铁承运部分</span><span>客户自运部分</span></div>*/}
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                                <div className='content-head-title'>其他信息</div>
                                <div className='spaceInfo-content-info'>
                                    {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A') ?
                                        <Row>
                                            <Col span={8}>
                                                <SelectFormItem
                                                    label='租箱地'
                                                    name="boxRentStation"
                                                    getFieldDecorator={getFieldDecorator}
                                                    initialValue={this.state.boxRentStation}
                                                    initialValueNull={true}
                                                    required={true}
                                                    disabledOpt={this.state.readOnly}
                                                    data={this.state.rentBox}
                                                    dataValue='content'
                                                    handleChange={e => {
                                                        handleChangeRentalBox(this, 'boxRentStation', e, 'rentBox')
                                                    }}
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <SelectFormItem
                                                    label='还箱地'
                                                    name="boxReturnStation"
                                                    getFieldDecorator={getFieldDecorator}
                                                    initialValue={this.state.boxReturnStation}
                                                    initialValueNull={true}
                                                    required={true}
                                                    disabledOpt={this.state.readOnly}
                                                    data={this.state.returnBox}
                                                    dataValue='content'
                                                    handleChange={e => {
                                                        handleChangeRentalBox(this, 'boxReturnStation', e, 'returnBox')
                                                    }}
                                                />
                                            </Col>
                                            <Col span={8}>
                                                <Form.Item label="箱型">
                                                    {getFieldDecorator('cabinetType', {
                                                        rules: [{required: true, message: '该项必填'}]
                                                    })(<CabinetTypeSelect
                                                        deliveryType={deliveryType}
                                                        subType={subType}
                                                        initialValue={this.state.cabinetType}
                                                        getFieldDecorator={getFieldDecorator}
                                                        setFieldsValue={setFieldsValue}
                                                        disabled={this.state.readOnly}/>)}
                                                </Form.Item>
                                            </Col>
                                        </Row> : null}
                                    <Row>
                                        <Col span={16}>
                                            <SelectFormItem
                                                label='货物类型'
                                                name="declareMode"
                                                getFieldDecorator={getFieldDecorator}
                                                initialValue={this.state.declareMode}
                                                required={true}
                                                disabledOpt={this.state.readOnly}
                                                data={this.state.declareModes}
                                                dataValue='businessCode'
                                                dataContent='businessName'
                                                handleChange={this.handleDeclareMode}
                                                layout={{labelCol: {span: 4}, wrapperCol: {span: 19}}}
                                            />
                                        </Col>
                                        {this.state.declareCityRequired ?
                                            <Col span={8}>
                                                <SelectFormItem
                                                    label='报关地'
                                                    name="declareCity"
                                                    getFieldDecorator={getFieldDecorator}
                                                    required={this.state.declareCityRequired}
                                                    data={this.state.declareCities}
                                                    dataValue='declareCity'
                                                    dataContent='declareCityName'
                                                />
                                            </Col> : null}
                                        <Col span={8}>
                                            <Form.Item label="保险">
                                                {getFieldDecorator('insureFeeType', {
                                                    initialValue: insureFeeType ? insureFeeType : 'D',
                                                    rules: [{required: true, message: '该项必填'}]
                                                })(<Radio.Group disabled={this.state.readOnly}>
                                                    <Radio value='D'>我司代办</Radio>
                                                    <Radio value='Z'>自办</Radio>
                                                </Radio.Group>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Form.Item label="转关手续">
                                                {getFieldDecorator('transitFeeType', {
                                                    initialValue: transitFeeType ? transitFeeType : 'D',
                                                    rules: [{required: true, message: '该项必填'}]
                                                })(<Radio.Group disabled={this.state.readOnly}>
                                                    <Radio value='D'>我司代办</Radio>
                                                    <Radio value='Z'>自办</Radio>
                                                </Radio.Group>)}
                                            </Form.Item>
                                        </Col>
                                        {deliveryType == 'G' ?
                                            <Col span={8}>
                                                <Form.Item label="班次时间">
                                                    {getFieldDecorator('trainDt', {
                                                        rules: [{required: true, message: '该项必填'}],
                                                    })(<DatePicker format="YYYY-MM-DD" style={{width: '100%'}}/>)}
                                                </Form.Item>
                                            </Col> : null}
                                        {PLAN_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                                            <Col span={8}>
                                                <Form.Item label="班次时间">
                                                    {getFieldDecorator('planDt', {
                                                        initialValue: this.state.planDt,
                                                        rules: [{required: true, message: '该项必填',},],
                                                    })(<Select>
                                                        {convertToOptions(this.state.planList)}
                                                    </Select>)}
                                                </Form.Item>
                                            </Col> : null}
                                    </Row>
                                </div>
                            </div>
                            <div className='content-head-title'>下单信息
                                <Button onClick={this.addBox}>添加</Button></div>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={8}>
                                        <Form.Item label="集装箱数">
                                            {getFieldDecorator('orderBatchPoList[0].quantity', {
                                                initialValue: '1',
                                                rules: [{required: true, message: '该项必填'}, {
                                                    pattern: /^[1-9]\d*$/, message: '必须为大于0的整数'
                                                }]
                                            })(<Input placeholder='集装箱数' readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) ?
                                        <Fragment>
                                            <Col span={8}>
                                                <Form.Item label="预计到达口岸" {...formItemLayout}>
                                                    {getFieldDecorator('orderBatchPoList[0].estimatePortDt', {
                                                        rules: [{required: true, message: '该项必填'}]
                                                    })(<DatePicker format="YYYY-MM-DD HH" style={{width: '100%'}}
                                                                   disabledDate={this.disabledStartDate}
                                                                   disabledTime={this.disabledDateTime}
                                                                   showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                                                   onChange={(current, dateString) => this.handleChangeEstimatePortDt(current, dateString, 0)}/>)}
                                                </Form.Item>
                                            </Col>
                                            {restStock[0] != null ?
                                                <Col span={8}>
                                                    <Form.Item label="剩余舱位">
                                                        {getFieldDecorator('stock', {})(
                                                            <span>{restStock[0]}</span>)}
                                                    </Form.Item>
                                                </Col> : null}
                                        </Fragment> : null}
                                    <Col span={8}>
                                        <Form.Item label="预计提货时间" {...formItemLayout}>
                                            {getFieldDecorator('orderBatchPoList[0].deliveryEstimateDt', {
                                                rules: [{required: true, message: '该项必填'}],
                                            })(<DatePicker
                                                format="YYYY-MM-DD HH" style={{width: '100%'}}
                                                onChange={(current, dateString) => this.onDateChange(current, dateString, 0)}
                                                disabledDate={this.disabledStartDate}
                                                disabledTime={this.disabledDateTime}
                                                showTime={{defaultValue: moment(new Date().getHours() + 1, 'HH')}}
                                            />)}
                                        </Form.Item>
                                    </Col>
                                    {TRAIN_PORT_DELIVERY_TYPE.hasOwnProperty(deliveryType) ?
                                        <Col span={8}>
                                            <Form.Item label="预计出境时间" {...formItemLayout}>
                                                {getFieldDecorator('orderBatchPoList[0].leaveCountryDt', {
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<DatePicker format="YYYY-MM-DD" style={{width: '100%'}}
                                                               disabledDate={this.disabledLeaveCountryDt}
                                                />)}
                                            </Form.Item>
                                        </Col> : null}
                                    {vehicleFlag ? <Fragment>
                                        {vehicleTypes.map((o, i) => {
                                            return <Col span={4}>
                                                <Form.Item {...formItemLayout2}
                                                           label={vehicleStock.length > 0 && vehicleStock[0] && vehicleStock[0][o] ?
                                                               '车型' + o + '(余' + vehicleStock[0][o] + ')' : '车型' + o}>
                                                    {getFieldDecorator('orderBatchPoList[0].vehicleTypes[' + o + ']', {
                                                        initialValue: i === 0 ? 1 : null,
                                                    })(<InputNumber min={0} step={1} style={{width: '90%'}}/>)}
                                                </Form.Item>
                                            </Col>
                                        })}
                                    </Fragment> : null}
                                </Row>
                                {rows}
                            </div>
                            <div className='content-head-title'>国内仓库信息
                                {secondPlace ? null :
                                    <Button onClick={e => this.setState({secondPlace: true})}>两地装柜</Button>}
                            </div>
                            <span><span>仓库联系人名称:</span></span>
                            <Select onChange={this.handledeliveryPlaceChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}>
                                {deliveryPlaceData.map(delivery => (
                                    <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('deliveryPlace', {
                                                initialValue: this.state.deliveryPlace,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(
                                                <Input onChange={e => {
                                                    this.setState({deliveryPlace: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('contact', {
                                                initialValue: this.state.contact,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(
                                                <Input onChange={e => {
                                                    this.setState({contact: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('contactTel', {
                                                initialValue: this.state.contactTel,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(
                                                <Input onChange={e => {
                                                    this.setState({contactTel: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            {secondPlace ? <Fragment>
                                <div className='content-head-title'>国内仓库信息2
                                    {secondPlace ?
                                        <Button
                                            onClick={e => this.setState({secondPlace: false})}>删除</Button> : null}
                                </div>
                                <span><span>仓库联系人名称:</span></span>
                                <Select onChange={this.handledeliveryPlaceChange2}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    {deliveryPlaceData.map(delivery => (
                                        <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                    ))}
                                </Select>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={12}>
                                            <Form.Item label="仓库地址" {...formItemLayout}>
                                                {getFieldDecorator('deliveryPlace2', {
                                                    initialValue: this.state.deliveryPlace2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系方式" {...formItemLayout}>
                                                {getFieldDecorator('contactTel2', {
                                                    initialValue: this.state.contactTel2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系人" {...formItemLayout}>
                                                {getFieldDecorator('contact2', {
                                                    initialValue: this.state.contact2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Fragment> : null}
                            <div className='content-head-title'>清关仓库信息(通知方)
                                {secondNotify ? null :
                                    <Button onClick={e => this.setState({secondNotify: true})}>两地清关</Button>}
                            </div>
                            <span><span>清关仓库信息:</span></span>
                            <Select onChange={this.handlenotifyPartyChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    disabled={this.state.readOnly}>
                                {notifyPartyData.map(notify => (
                                    <Option key={notify.id} value={notify.id}>{notify.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库名称" {...formItemLayout}>
                                            {getFieldDecorator('notifyParty', {
                                                initialValue: this.state.notifyParty,
                                                rules: [{required: declareWhRequired, message: '该项必填'}],
                                            })(<Input onChange={e => {
                                                    this.setState({notifyParty: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyAddr', {
                                                initialValue: this.state.notifyPartyAddr,
                                                rules: [{required: declareWhRequired, message: '该项必填'}],
                                            })(<Input onChange={e => {
                                                    this.setState({notifyPartyAddr: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyContact', {
                                                initialValue: this.state.notifyPartyContact,
                                                rules: [{required: declareWhRequired, message: '该项必填'}],
                                            })(<Input onChange={e => {
                                                    this.setState({notifyPartyContact: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyTel', {
                                                initialValue: this.state.notifyPartyTel,
                                                rules: [{required: declareWhRequired, message: '该项必填'}],
                                            })(<Input onChange={e => {
                                                    this.setState({notifyPartyTel: e.target.value})
                                                }} readOnly={this.state.readOnly}/>,
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="海关编码" {...formItemLayout}>
                                            {getFieldDecorator('notifyPartyCustomsCode', {
                                                initialValue: this.state.notifyPartyCustomsCode,
                                                rules: [{
                                                    required: declareWhRequired && DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M',
                                                    message: '该项必填'
                                                }]
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            {secondNotify ? <Fragment>
                                <div className='content-head-title'>清关仓库信息(通知方)2
                                    {secondNotify ?
                                        <Button
                                            onClick={e => this.setState({secondNotify: false})}>删除</Button> : null}
                                </div>
                                <span><span>仓库联系人名称:</span></span>
                                <Select onChange={this.handlenotifyPartyChange2}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    {notifyPartyData.map(delivery => (
                                        <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                    ))}
                                </Select>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={12}>
                                            <Form.Item label="仓库名称" {...formItemLayout}>
                                                {getFieldDecorator('notifyParty2', {
                                                    initialValue: this.state.notifyParty2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库地址" {...formItemLayout}>
                                                {getFieldDecorator('notifyPartyAddr2', {
                                                    initialValue: this.state.notifyPartyAddr2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系人" {...formItemLayout}>
                                                {getFieldDecorator('notifyPartyContact2', {
                                                    initialValue: this.state.notifyPartyContact2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系方式" {...formItemLayout}>
                                                {getFieldDecorator('notifyPartyTel2', {
                                                    initialValue: this.state.notifyPartyTel2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>,)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="海关编码" {...formItemLayout}>
                                                {getFieldDecorator('notifyPartyCustomsCode2', {
                                                    initialValue: this.state.notifyPartyCustomsCode2,
                                                    rules: [{
                                                        required: DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && deliveryType !== 'M',
                                                        message: '该项必填'
                                                    }]
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Fragment> : null}
                            <div className="content-head-title">目的仓库信息(卸货仓)
                                <span style={{marginLeft: '10px'}}>
                                        <Checkbox value="sameConsignee" disabled={this.state.readOnly}
                                                  onChange={e => {
                                                      this.handleChangeSame(e.target.checked)
                                                  }}>同清关仓库</Checkbox>
                                    {secondConsignee ? null :
                                        <Button onClick={e => this.setState({secondConsignee: true})}>两地卸货</Button>}
                                </span>
                            </div>
                            <span><span>目的仓库信息:</span></span>
                            <Select onChange={this.consigneeHandleChange}
                                    getPopupContainer={triggerNode => triggerNode.parentNode}
                                    disabled={this.state.readOnly}>
                                {consigneeData.map(d => (
                                    <Option key={d.id} value={d.id}>{d.company}</Option>
                                ))}
                            </Select>
                            <div className='spaceInfo-content-info'>
                                <Row>
                                    <Col span={12}>
                                        <Form.Item label="仓库名称" {...formItemLayout}>
                                            {getFieldDecorator('consignee', {
                                                initialValue: this.state.consignee,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(<Input onChange={this.consigneeChange}
                                                      readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库地址" {...formItemLayout}>
                                            {getFieldDecorator('consigneeAddr', {
                                                initialValue: this.state.consigneeAddr,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(<Input onChange={this.consigneeAddrChange}
                                                      readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系人" {...formItemLayout}>
                                            {getFieldDecorator('consigneeContact', {
                                                initialValue: this.state.consigneeContact,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(<Input onChange={this.consigneeContactChange}
                                                      readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="仓库联系方式" {...formItemLayout}>
                                            {getFieldDecorator('consigneeTel', {
                                                initialValue: this.state.consigneeTel,
                                                rules: [{required: whRequired, message: '该项必填'}],
                                            })(<Input onChange={this.consigneeTelChange}
                                                      readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item label="海关编码" {...formItemLayout}>
                                            {getFieldDecorator('consigneeCustomsCode', {
                                                initialValue: this.state.consigneeCustomsCode,
                                            })(<Input readOnly={this.state.readOnly}/>)}
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                            {secondConsignee ? <Fragment>
                                <div className='content-head-title'>目的仓库信息(卸货仓)2
                                    {secondConsignee ?
                                        <Button
                                            onClick={e => this.setState({secondConsignee: false})}>删除</Button> : null}
                                </div>
                                <span><span>仓库联系人名称:</span></span>
                                <Select onChange={this.consigneeHandleChange2}
                                        getPopupContainer={triggerNode => triggerNode.parentNode}>
                                    {consigneeData.map(delivery => (
                                        <Option key={delivery.id} value={delivery.id}>{delivery.company}</Option>
                                    ))}
                                </Select>
                                <div className='spaceInfo-content-info'>
                                    <Row>
                                        <Col span={12}>
                                            <Form.Item label="仓库名称" {...formItemLayout}>
                                                {getFieldDecorator('consignee2', {
                                                    initialValue: this.state.consignee2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库地址" {...formItemLayout}>
                                                {getFieldDecorator('consigneeAddr2', {
                                                    initialValue: this.state.consigneeAddr2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系人" {...formItemLayout}>
                                                {getFieldDecorator('consigneeContact2', {
                                                    initialValue: this.state.consigneeContact2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="仓库联系方式" {...formItemLayout}>
                                                {getFieldDecorator('consigneeTel2', {
                                                    initialValue: this.state.consigneeTel2,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item label="海关编码" {...formItemLayout}>
                                                {getFieldDecorator('consigneeCustomsCode2', {
                                                    initialValue: this.state.consigneeCustomsCode2,
                                                })(<Input readOnly={this.state.readOnly}/>)}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Fragment> : null}
                            <UserModal onOk={this.onOk}
                                       onRef={this.onRef}
                                       updateKey={updateKey}
                                       visible={visible} onCancel={this.onCancel}/>
                            <div className='box-submit'>
                                <AuthFormItem authority="order_start:commit" {...tailFormItemLayout} >
                                    <Button type="primary" htmlType="submit"
                                            style={{marginRight: '10px'}}>保存</Button>
                                    {payFlag ? null :
                                        deliveryType == 'G' ?
                                            <Popconfirm title={<div>批量下单<br/>
                                                下单数量： {getFieldDecorator('orderQuantity', {
                                                    initialValue: 1,
                                                    rules: [{required: true, message: '该项必填'}],
                                                })(<InputNumber min={1} step={1}/>)}
                                            </div>} onConfirm={e => this.handleSaveSubmit(e, 'Y')}>
                                                <Button type='primary'>保存并提交</Button>
                                            </Popconfirm> :
                                            <Popconfirm title="是否确定保存并提交?"
                                                        onConfirm={e => this.handleSaveSubmit(e, 'Y')}>
                                                <Button type='primary'>保存并提交</Button>
                                            </Popconfirm>
                                    }
                                    {restCancelTime.length > 0 ?
                                        <span> 保存后，请在{cancelTime}小时内提交订单，否则订单将自动取消</span> : null}
                                </AuthFormItem>
                            </div>
                        </Form>
                    </Spin>
                </div>
            </div>
        )
    }
}

const WrapOrderTicket = authorizePage("order_start:commit")(Form.create()(OrderTicket))
export default WrapOrderTicket